import { useEffect, useState } from 'react';

import { BUTTON_FONT } from 'components/landing/constants';
import ButtonContainer from 'core/button-container';
import LandingSection from 'components/landing/components/landing-section';
import { PinkButton } from 'core/buttons/buttons';
import Slider from 'components/home/insurace/insurace-slider/insurace-slider';
import Text from 'core/text';
import Title from 'core/title';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useTranslations } from 'next-intl';

const InsuranceSlider = () => {
    const { seoText, verification } = useGetSeoTextByIndex('compare');
    const t = useTranslations('compare');
    const [isFullSize, setFullSize] = useState(false);

    useCustomMediaQuery(992, (e) => {
        setFullSize(e.matches);
    });

    useEffect(() => {
        setFullSize(window.innerWidth > 992);
    }, []);

    if (!verification) {
        // TODO: Add sentry controlled exception
        return null;
    }

    return (
        <LandingSection>
            <Title align content={seoText.section_title} />
            <Slider />
            <Text
                align
                content={seoText.paragraph1.sentence1}
                width={isFullSize ? '40%' : '100%'}
                marginBottom="40px"
            />
            <ButtonContainer>
                <PinkButton
                    label={`${t('button.label')} &#10095;`}
                    href={t('button.href')}
                    propsButton={BUTTON_FONT}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

export default InsuranceSlider;
